/**
 * =============================================================================
 * SverkerCarlsson.tsx - Sverker Carlsson Author Profile Page
 * =============================================================================
 *
 * ROUTE: /om-oss/sverker-carlsson
 *
 * PURPOSE:
 *   Dedicated profile page for Sverker Carlsson, co-founder and product lead
 *   E-E-A-T compliant author page for YMYL content
 *
 * CONTENT:
 *   - Full biography with Nova Omsorg background
 *   - Credentials and qualifications
 *   - Operational expertise in home care
 *   - List of articles authored by Sverker
 *
 * TARGET AUDIENCE: Anyone wanting to learn more about Sverker's expertise
 *
 * SEO FOCUS: E-E-A-T signals, author credibility for healthcare content
 * =============================================================================
 */

import React from "react";
import { AuthorPage, sverkerCarlsson } from "@appcaire/shared/seo";

const SverkerCarlssonPage: React.FC = () => {
  // List of articles by Sverker on Nacka Hemtjänst
  const articles = [
    {
      title: "Hemtjänstanordnare i Nacka | Översikt",
      url: "/utforare",
      publishDate: "2026-01-20",
      description:
        "Omfattande översikt av alla godkända hemtjänstutförare i Nacka kommun.",
    },
    {
      title: "Om Nacka Hemtjänst",
      url: "/om-nacka-hemtjanst",
      publishDate: "2026-01-25",
      description:
        "Bakgrund och information om hemtjänsten i Nacka kommun och dess utveckling.",
    },
  ];

  return (
    <AuthorPage
      author={sverkerCarlsson}
      siteName="Nacka Hemtjänst"
      siteUrl="https://nackahemtjanst.se"
      articles={articles}
      backUrl="/om-nacka-hemtjanst"
    />
  );
};

export default SverkerCarlssonPage;
